(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const customer_stories_swiper = new Swiper('.customer-stories-swiper', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      centerInsufficientSlides: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5
        }
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const featured_collection_swiper = new Swiper('.features-collection', {
      loop: false,
      slidesPerView: 2,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 4
        },
        1025: {
          slidesPerView: 5
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-collections"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const featured_collections_swiper = new Swiper('.features-collections', {
      loop: false,
      slidesPerView: 2,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
